import { combineReducers } from 'redux'

import candidates from './candidates/reducers'

const jobReducer = combineReducers({
  candidates,
})

export default jobReducer
